var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common_panel"},[_c('span',[_vm._v(_vm._s(_vm.LandmarkLayerIdObj.indexOf('机柜') !== -1 || _vm.LandmarkLayerIdObj.indexOf('电池') !== -1 ? _vm.LandmarkLayerIdObj : _vm.LandmarkLayerIdObj))])])
}
var staticRenderFns = []

export { render, staticRenderFns }